import { OnInit, Component, Inject, ChangeDetectionStrategy} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AppService } from "@irb/app.service";
import { PortfolioService } from "../portfolios/portfolio.service";
import {
    EditMultiplePortfoliosAutomationDialogGridLayoutService
} from "@irb/irb-clients/edit-multiple-portfolios-automation-dialog/edit-multiple-portfolios-automation-dialog.grid-layout.service";

@Component({ standalone: false,
    selector: 'edit-multiple-portfolios-automation-dialog',
    templateUrl: './edit-multiple-portfolios-automation-dialog.component.html',
    styleUrls: ['./edit-multiple-portfolios-automation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class EditMultiplePortfoliosAutomationDialogComponent implements OnInit {
    portfolioTarget = new FormControl();
    portfolios: Array<number>;
    editMultiplePFContinueFunction: Function;
    grid: any;
    gridOptions: any;
    constructor(public dialogRef: MatDialogRef<EditMultiplePortfoliosAutomationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public mdd: any,
        private as: AppService,
        private readonly portfolioService: PortfolioService,
        private gls: EditMultiplePortfoliosAutomationDialogGridLayoutService) {
    }

    ngOnInit(): void {
        let columns: any = this.gls.getColumnDefs();
        if (this.mdd.noTotalAccount) {
            columns[1].hide = true;
            columns[0].width = 650;
        }
        this.gridOptions = {
            columnDefs: columns,
            frameworkComponents: this.gls.getFrameworkComponents(),
            floatingFilter: false,
            overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
            context: { componentParent: this }
        };
        this.portfolios = this.mdd.portfolios as Array<number>;
        this.editMultiplePFContinueFunction = this.mdd.editMultiplePFContinueFunction || null;
    }

    close() {
        this.dialogRef.close();
    }

    editSelectedPortfolios() {
        this.editMultiplePFContinueFunction();
        this.close();
    }
    onGridReady(params: any) {
        this.grid = params;
    }
}
